import * as React from 'react';
import { connect } from 'react-redux';

import { SearchTags } from '../../../../common/components/search_tags';
import { Dispatch, IAppState } from '../../../../common/state';
import { wordExcludeAdded, wordExcludeRemoved } from '../../../state/advanced/words_exclude';
import { InlineParam, Row } from '../markup';

interface IWordsExcludeProps {
  wordsExclude: string[];
  isModerator: boolean;
  onWordExcludeAdded(word: string): void;
  onWordExcludeRemoved(word: string): void;
}

export const WordsExclude: React.FC<IWordsExcludeProps> = props => (
  <Row title="Исключить слова">
    <InlineParam>
      <SearchTags
        isModerator={props.isModerator}
        words={props.wordsExclude}
        onWordAdded={word => props.onWordExcludeAdded(word)}
        onWordRemoved={word => props.onWordExcludeRemoved(word)}
        tagStyle={{ backgroundColor: 'rgba(255,80,80,.2)', color: '#121212' }}
      />
    </InlineParam>
  </Row>
);

export const mapStateToProps = (state: IAppState) => ({
  wordsExclude:
    (state.filters.jsonQuery.description_exclude && state.filters.jsonQuery.description_exclude.value) || [],
  isModerator: state.user.isAuthenticated && state.user.isModerator,
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onWordExcludeAdded: (word: string) => {
    dispatch(wordExcludeAdded(word));
  },
  onWordExcludeRemoved: (word: string) => {
    dispatch(wordExcludeRemoved(word));
  },
});

// tslint:disable-next-line:no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(WordsExclude);
